var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-container-window-check',{attrs:{"keyName":_vm.keyName,"items":_vm.listCheckBox,"programs":_vm.programsList},on:{"finish":function($event){return _vm.$emit('finish', $event)},"getObj":_vm.getObj}})}
var staticRenderFns = []

export { render, staticRenderFns }